// extracted by mini-css-extract-plugin
module.exports = {"paywallModal":"ModalPane_paywallModal__Gp9S1","paywallModalBody":"ModalPane_paywallModalBody__oVGwy"};